import '../../config/common';

export { useSSO } from './hooks';
